import React from 'react'

import "./skill.css";


import html from  "./htmsk.webp";


import css from  "./programming-language-css.jpeg";

import boot from  "./bootsk.webp";

import js from  "./jssk.webp";

import php from  "./phpsk.webp";

import c from  "./Clanguage.png";

import cpp from  "./cppsk.webp";


import java from  "./javask.webp";


import hack from  "./hacksk.webp";


import sql from  "./sqlsk-removebg-preview.png";


import firebase from  "./firebase-removebg-preview.png";

import react1 from  "./reactski.png";

import Typewriter from "typewriter-effect";

import next from  "./nextski-removebg-preview.png";
export default function skills() {

let da=[

{
im:html

},

{
im:css

},

{
im:js

}
,

];


let d2=[


{
im:boot

},

{
im:php

},

{
im:sql

},
];

let d3=[


{
im:react1

},

{
im:next

},

{
im:firebase

},

];

let d4=[
{
im:c

},
{
im:cpp

},
{
im:java

},

];



	return (
		<div style={{}}>
			<h1 className="text-center font-bold h2h">
			My Skills.</h1>

<div style={{width:"80%" ,margin:"auto"}}>

<h2 className="text-center font-bold h2h">

<Typewriter
  

options={{
    delay: 75,
    autoStart: true,
    
  }}


       onInit={(typewriter)=> {

       typewriter
        
       .typeString("Passionate about new technologies,I keep exploring stuff.Here's the tech stack I've worked with!")
         

  


       .start();
       }}
       /> 


</h2>



		</div>	

<div className="d-flex flex-wrap justify-content-between px-5 align-items-center mt-20 box" style={{width:"100%",height:"100%",marginTop: "70px" }}>
<div>

{

da.map((i)=>(
<>
<img src={i.im} key={i} className="immg" />	

</>
))

}


</div>


<div>

{

d2.map((i)=>(
<>
<img src={i.im} className="immg1"/>	

</>
))

}
</div>
</div>







<div className="d-flex flex-wrap justify-content-between px-5 box1 mt-20" style={{width:"100%",height:"00%",marginTop: "70px"}}>
<div>

{

d3.map((i)=>(
<>
<img src={i.im} className="immg2" />	

</>
))

}


</div>


<div>

{

d4.map((i)=>(
<>
<img src={i.im} className="immg3" />	

</>
))

}
</div>
</div>

<h4 className=" font-bold h2h">
			Do checkout my hackerrank profile <a href="https://www.hackerrank.com/anuragt9510" style={{textDecoration:"none" ,color:"green"}}>here</a></h4>

 <a href="https://www.hackerrank.com/anuragt9510" style={{textDecoration:"none" ,color:"green"}}>
<img src={hack}  className="immghack"/>
</a>
		</div>
	)
}